import React from 'react'
import { useTheme } from 'styled-components'
import { useMediaQuery } from '../../core/application/hooks'
import { deviceSizes } from '../../core/application/theme/breakpoints'

const PlusIcon = () => {

  const isMobile = useMediaQuery(parseInt(deviceSizes.tablet))
  const { color } = useTheme()
  const fillColor = isMobile ? color.black : color.secondary

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.2852 13.3422L19.2852 11.2852L13.0285 11.2852L13.0285 5.02852L10.9715 5.02852L10.9715 11.2852L4.71481 11.2852L4.71481 13.3422L10.9715 13.3422L10.9715 19.5989L13.0285 19.5989L13.0285 13.3422L19.2852 13.3422Z" fill={fillColor}/>
    </svg>
  )
}

export default PlusIcon
